import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_CONDITIONAL_KICKSTART = createFcmDetails('starfish_conditional_kickstart', {
	owner: 'starfish',
	context: 'Conditional Kickstart',
	description:
		'Feature toggle for the conditional kickstart UI in the starter onboarding flow that is tied to an experiment `starfishConditionalKickstart`',
	import: false,
	mergeLogic: 'Needs combination of both country code and locale to be enabled',
});
